.contentLoader {
  height: 66px;
  width: 66px;
}
